export const flagsmithFeatureFlags = {
  ADD_TO_LIST_FROM_ALERTS: 'add_to_list_from_alerts',
  AGENT_COMMAND_VISIBILITY: 'agent_command_visibility',
  // KIR-5191: agent auto-update (Settings switch, update states, fleet
  // summary, "Try update now"). Must match the backend
  // `featureFlagKeys.agent_auto_update` value. Off by default.
  AGENT_AUTO_UPDATE: 'agent_auto_update',
  // KIR-4445: alert "Session" block + session timeline drawer.
  AGENT_SESSION_TIMELINE: 'agent_session_timeline',
  // KIR-4703: gates only the user-facing Browser Agent Sites surfaces (the nav
  // tab + page). Backend keeps collecting; off by default.
  BROWSER_AGENT_ACTIVITY: 'browser_agent_activity',
  // KIR-4165: backend-gated; listed for the docs' <FeatureFlag> section.
  CHAT_SECURITY_PER_MATCH_AI: 'chat_security_per_match_ai',
  // TODO: rename Flagsmith flag from 'ai_rules_policy' → 'ai_instructions_policy' then align this value
  AI_INSTRUCTIONS_POLICY: 'ai_rules_policy',
  // KIR-3515 AI Instruction Security Policy Catalog (group + Manage-catalog page);
  // KIR-3925 also gates the AI AppSec pages (Threat Modeling + LLM Vulnerability Discovery)
  AI_INSTRUCTION_CATALOG: 'ai_instruction_catalog',
  ALERT_FEEDBACK: 'alert_feedback',
  ALERT_SEVERITY_OVERRIDE: 'alert_severity_override',
  ALERT_SOURCE_DETAILS: 'alert_source_details',
  // KIR-4272: gates the Alert Details "Detection Logic" section, which
  // explains the finding-specific reason detection fired.
  ALERT_DETECTION_LOGIC: 'alert_detection_logic',
  // KIR-4282: gates the Session ID column on Alert Variations occurrence
  // rows. Frontend-only — payload still rides `secret_detection_details`.
  // Off by default; flag-off leaves the parent More-details Session ID
  // (and every other surface) unchanged.
  ALERT_OCCURRENCE_SESSION_ID: 'alert_occurrence_session_id',
  // KIR-4271: gates the Alert Details "Recommended actions" section — the
  // Security-approved mitigation copy for a mapped (subPolicyKey, type) pair.
  // Must match the backend `featureFlagKeys.alert_recommended_actions` value:
  // the same key gates the `mitigation` field on /api/v1, so the API and the
  // screen turn on together per org.
  ALERT_RECOMMENDED_ACTIONS: 'alert_recommended_actions',
  // KIR-4481: gates the redesigned Alert Details panel — a facts strip plus
  // grouped, colour-accented cards — in place of the flat label list. Pure
  // presentation: no new data, so flag-off renders the legacy AlertDetailCard.
  ALERTS_GROUPED_CARDS: 'alerts_grouped_cards',
  // KIR-4089: gates the Alerts table "Columns" customize panel (show / hide /
  // reorder, saved per user) and the right-edge "more columns" sign.
  // Frontend-only — the `alerts_table_columns` preference key is harmless
  // when unused. Flag-off renders today's fixed column set.
  ALERTS_COLUMN_CUSTOMIZATION: 'alerts_column_customization',
  ALERTS_REVAMP: 'enable_alerts_revamp',
  BITBUCKET_INTEGRATION: 'bitbucket_integration',
  ENFORCE_POLICY_MODE: 'enforce_policy_mode',
  ENABLE_ORGANIZATION_DASHBOARD: 'enable_dashboard_module',
  // KIR-5075: AI Risk Map dashboard view.
  AI_RISK_MAP: 'ai_risk_map',
  ENDPOINT_IDENTIFIER: 'endpoint_identifier',
  EXTENSION_CODE_SCAN: 'extension_code_scan',
  GITHUB_INTEGRATION: 'github_integration',
  HOOK_INVENTORY_ENABLED: 'hook_inventory_enabled',
  // KIR-5155: gates the in-app help (header Help button, per-screen help and
  // the full-docs dialog). Frontend-only: the docs themselves are static files
  // under /help/. Off by default.
  IN_APP_DOCS: 'in_app_docs',
  HOOK_PREVENTION_MODE: 'hook_prevention_mode',
  HIDE_VSCODE_EXTENSION: 'hide_vscode_extension',
  LINUX_AGENT_RELEASE: 'linux_agent_release',
  // KIR-3746: gates the Settings → API Keys management-key surface (KIR-3748)
  // and the public /api/v1 namespace. Must match the backend
  // `featureFlagKeys.management_api_keys` value.
  MANAGEMENT_API_KEYS: 'management_api_keys',
  // KIR-4443: gates the Packages page Enforcement column, its filter and the
  // Allow/Block actions. Must match the backend `featureFlagKeys.malicious_packages`
  // value, which registers the malicious-packages / packages-management policies.
  MALICIOUS_PACKAGES: 'malicious_packages',
  PLATFORM_ANTIGRAVITY: 'platform_antigravity',
  PLATFORM_CLAUDE_DESKTOP: 'platform_claude_desktop',
  PLATFORM_CODEX: 'platform_codex',
  PLATFORM_GEMINI_CLI: 'platform_gemini_cli',
  PLATFORM_GITHUB_COPILOT_CLI: 'platform_github_copilot_cli',
  PLATFORM_WINDSURF: 'platform_windsurf',
  PROJECTS_INVENTORY: 'projects_inventory',
  SECRET_CONFIDENCE_THRESHOLD: 'secret_confidence_threshold',
  // KIR-3800: gates the Security Groups pages and the Policies scope selector.
  // Must match the backend `featureFlagKeys.security_groups_policies` value —
  // the same flag gates the group-scoped policy APIs this UI calls.
  SECURITY_GROUPS_POLICIES: 'security_groups_policies',
  SECRET_DETECTION_DETAILS: 'secret_detection_details',
  // KIR-4590: gates the Secret Detection Rules policy section, the editor
  // page, and
  // the alert's Manage-rule action. Off by default.
  GITLEAKS_RULE_MANAGEMENT: 'gitleaks_rule_management',
  SHADOW_AI_NETWORK_DISCOVERY: 'shadow_ai_network_discovery',
  AI_MCP_TOOL_ANALYSIS: 'ai_mcp_tool_analysis',
  // KIR-4426: gates the nested Real-Time Tool-Call Analysis toggle under
  // Chat & Tool-Call Security. Off by default.
  AI_TOOL_CALL: 'ai_tool_call',
  // KIR-3940: gates the Inventory MCP Servers tab's gateway allow/block UI
  // (source badge/filter, gateway-control column, tool-list expansion). Off
  // in prod until backend slices 2a/2b land; slice 1 runs entirely on
  // fixture data behind this flag.
  MCP_GATEWAY_CONTROL: 'mcp_gateway_control',
  // KIR-4482: gates the Inventory MCP Servers New signal (badge, banner,
  // New/Blocked chips) and the hook-enforced Enforcement column. Must match
  // the backend `featureFlagKeys.mcp_inventory_enforcement` value.
  MCP_INVENTORY_ENFORCEMENT: 'mcp_inventory_enforcement',
  AGENTMESH_RISK_ESTIMATE: 'agentmesh_risk_estimate',
  // KIR-5108 Inventory → MCP Servers Risk column and card. Separate from the
  // Extensions estimate above; must match `featureFlagKeys.agentmesh_mcp_risk`.
  AGENTMESH_MCP_RISK: 'agentmesh_mcp_risk',
  CAPABILITY_DETECTION: 'capability_detection',
  MCP_TOOL_RESPONSE_SCANNING: 'mcp_tool_response_scanning',
  SHADOW_AI: 'shadow_ai',
  SHADOW_AI_LOGGED_IN_USER: 'shadow_ai_logged_in_user',
  // KIR-4854: Shadow AI Tools approval column + "Show" filter. Off by default.
  SHADOW_AI_TOOL_APPROVAL: 'shadow_ai_tool_approval',
  SHOW_DATA_COLLECTION_SETTINGS: 'show_data_collection_settings',
  SHOW_VSIX_DOWNLOAD: 'show_vsix_download',
  SIEM_INTEGRATION: 'siem_integration',
  // KIR-4699: Inventory → Skills. While on, the AI Instructions tab hides
  // skills. Must match the backend `featureFlagKeys.skills_inventory` value.
  SKILLS_INVENTORY: 'skills_inventory',
  SLACK_SCAN_LOGS_EVENTS: 'slack_scan_logs_events',
  SSO_LOGIN: 'okta_sso_login',
  DATATABLE_LOCAL_PREFERENCES: 'datatable_local_preferences',
  DATATABLE_URL_STATE: 'datatable_url_state',
  EDIT_POLICY_FROM_ALERTS: 'edit_policy_from_alerts',
  // KIR-5055: gates the "Try the new UI" opt-in and the UI v2 shell itself.
  // Frontend-only kill switch; off forces Classic even for a browser that
  // already opted in. Off by default.
  UI_V2_SHELL: 'ui_v2_shell',
} as const;

export type FlagsmithFeatureFlag =
  (typeof flagsmithFeatureFlags)[keyof typeof flagsmithFeatureFlags];
